import { HIDDEN_CHILD_TYPES } from './consts';
import { CatalogTableAssetData, CatalogTableAssetResponseItem } from './types';

const parseAsset = (
  asset: CatalogTableAssetResponseItem,
): CatalogTableAssetData | null => {
  if (HIDDEN_CHILD_TYPES.has(asset.displayType)) {
    return null;
  }
  return {
    ...asset,
    assetType: asset.displayType,
    artifactType: asset.artifactType,
    materialization: asset.materialization || '',
    description: asset.description || '',
    latestExecution: asset.latestExecution,
  };
};

export const parseAssets = (
  assets: CatalogTableAssetResponseItem[],
): CatalogTableAssetData[] =>
  assets.flatMap((asset) => {
    const parsedAsset = parseAsset(asset);
    return parsedAsset ? [parsedAsset] : [];
  });
